// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__OsaVP","legacyBtn":"MutateMid_legacyBtn__1gN03"};